export const ChapterHeading = ({ number, title, intro }) => (
  <div className="mb-10">
    <div className="flex items-baseline gap-4 mb-4">
      <span className="text-sm font-bold tracking-[0.3em] text-primary/60">{number}</span>
      <span className="h-px flex-1 bg-border" aria-hidden="true" />
    </div>
    <h2 className="text-2xl sm:text-3xl lg:text-4xl font-bold tracking-tight text-foreground">{title}</h2>
    {intro && <p className="mt-3 text-base text-muted-foreground max-w-2xl">{intro}</p>}
  </div>
);
